// extracted by mini-css-extract-plugin
module.exports = {"modalBackground":"styles_modalBackground__3eeA0","p0Login":"styles_p0Login__31K70","modal":"styles_modal__-GdbD","modalContent":"styles_modalContent__1q65u"};